export default "__VITE_ASSET__BBxR_9q8__"